"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const AntBoardLoader_1 = require("../../../problems/santa-fe/AntBoardLoader");
exports.default = () => {
    const [antBoard, setAntBoard] = React.useState(null);
    const [inputL, setInputL] = React.useState(false);
    const [inputR, setInputR] = React.useState(false);
    function renderAntBoard(board) {
        return (React.createElement("div", null,
            "Ant is facing: ",
            board.antDirection,
            ". Food: ",
            board.foodGathered,
            ". Turn:",
            " ",
            board.turns,
            ".",
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    const tempBoard = board.reset();
                    setAntBoard(Object.create(tempBoard));
                }) }, "Reset"),
            " ",
            React.createElement("br", null),
            "Input L:",
            " ",
            React.createElement("input", { type: "checkbox", checked: inputL, onChange: () => {
                    setInputL(!inputL);
                } }),
            "Input R:",
            React.createElement("input", { type: "checkbox", checked: inputR, onChange: () => {
                    setInputR(!inputR);
                } }),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    const tempBoard = board.executeAction(inputL, inputR);
                    setAntBoard(Object.create(tempBoard));
                }) }, "Send input"),
            board.currentBoard.map((row, i) => (React.createElement("div", null, row.map((cell, j) => (React.createElement("span", null,
                board.antPosition[0] === i && board.antPosition[1] === j
                    ? "A"
                    : cell
                        ? "X"
                        : ".",
                " "))))))));
    }
    return (React.createElement("div", null,
        React.createElement("p", null, "One of the things I would like to play around with is sequences. Basically data with a temporal element, where future points potentially rely on information from past points. While I could feed some history of points, it would be better if the program itself could decide what's important, and what should be saved."),
        React.createElement("p", null,
            "There's the concept of Recurrent Neural Networks and variants (such as the popular LLM) that introduce hidden states that are preserved during a run of a sequence. A similar concept was proposed for Recurrent Cartesian Genetic Programming (RCGP) in",
            React.createElement("a", { href: "https://link.springer.com/chapter/10.1007/978-3-319-10762-2_47" }, "Parallel Problem Solving from Nature"),
            "."),
        React.createElement("p", null, "The actual implementation of RCGP will be saved for later, as first we need a sample problem that justifies using it. Luckily, that chapter proposes such a problem of the Artificial Ant."),
        React.createElement("p", null, "The task is to navigate an ant around a toroidal map, getting as much food as possible. The ant can only view the spot in front of it to see if there's food. Each step, the ant can move forward, turn left/right, or wait."),
        React.createElement("p", null, "Below is the Santa Fe trail used in this problem. This post is simply to introduce the problem, and demonstrate that the implementation works as expected. While there are unit tests, seeing a solution is so much more satisfying."),
        React.createElement("p", null, "I also added async loading from the public/ directory, to separate data from code. This will be vital as the datasets grow larger."),
        antBoard === null && (React.createElement("button", { type: "button", onClick: (e) => __awaiter(void 0, void 0, void 0, function* () {
                const board = yield (0, AntBoardLoader_1.loadFromUrl)("/data/santa-fe-ant-trail.csv");
                setAntBoard(board);
            }) }, "Load Trail")),
        antBoard !== null && renderAntBoard(antBoard)));
};
